var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section text-left" }, [
    _c("h3", { staticClass: "sr-only" }, [_vm._v("Services")]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "fa-ul", staticStyle: { "--list-margin-top": "0" } },
      [
        _c("li", { staticClass: "margin-bottom-sm padding-left-sm" }, [
          _c(
            "span",
            { staticClass: "fa-li" },
            [
              _c("font-awesome-icon", {
                class: `${_vm.context.download.iconColor}`,
                attrs: { icon: _vm.context.download.icon, size: "lg" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.context.download.hasAccessToProDownloads
            ? _c(
                "span",
                {
                  attrs: {
                    "aria-label":
                      "Use Pro icons on the web through Kits and CDN. Offline downloads are not included.",
                    "data-balloon-pos": "up",
                    "data-balloon-length": "large",
                  },
                },
                [_vm._v("\n        Online Icons Only\n      ")]
              )
            : _c(
                "span",
                {
                  attrs: {
                    "aria-label":
                      "Gives you permission to download Font Awesome Pro icons.",
                    "data-balloon-pos": "up",
                    "data-balloon-length": "large",
                  },
                },
                [_vm._v("\n        Pro Icon Downloads\n      ")]
              ),
        ]),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "margin-bottom-sm padding-left-sm" },
          [
            _c(
              "span",
              { staticClass: "fa-li" },
              [
                _c("font-awesome-icon", {
                  class: `${_vm.context.license.iconColor}`,
                  attrs: { icon: _vm.context.license.icon, size: "lg" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.context.license.hasPerpetualLicense && !_vm.$dt.isBacker
              ? _c(
                  "site-link",
                  {
                    attrs: {
                      to: { name: "license.pro" },
                      "aria-label":
                        "Web use included via Kits and CDN. Without a perpetual license, use is limited to the web. Lifetime access, self-hosting, desktop use, and native apps are not included.",
                      "data-balloon-pos": "up",
                      "data-balloon-length": "large",
                    },
                  },
                  [_vm._v("\n        Limited License\n      ")]
                )
              : _vm.context.license.hasProBackerLicenseOnly
              ? _c(
                  "site-link",
                  {
                    attrs: {
                      to: {
                        name: "support",
                        hash: "#font-awesome-5-kickstarter-pre-order-licenses",
                      },
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture("support_link_click", {
                          context: "plan_card",
                          location: "backer_license",
                        })
                      },
                    },
                  },
                  [_vm._v("\n        Backer Pro License\n      ")]
                )
              : _c(
                  "site-link",
                  {
                    attrs: {
                      to: { name: "license.pro" },
                      "aria-label":
                        "Includes a perpetual license for Pro icons. You get lifetime access to the Pro icons available during your subscription, for use beyond Kits and CDN, including self-hosting, desktop use, and native apps.",
                      "data-balloon-pos": "up",
                      "data-balloon-length": "large",
                    },
                  },
                  [_vm._v("\n        Perpetual License\n      ")]
                ),
          ],
          1
        ),
        _vm._v(" "),
        _c("li", { staticClass: "margin-bottom-sm padding-left-sm" }, [
          _c(
            "span",
            { staticClass: "fa-li" },
            [
              _c("font-awesome-icon", {
                class: `${_vm.context.support.iconColor}`,
                attrs: { icon: _vm.context.support.icon, size: "lg" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.context.support.hasAccessToHumanSupport
            ? _c(
                "span",
                {
                  class: _vm.serviceStylingUnavailable,
                  attrs: {
                    "aria-label":
                      "Get help from a real human when you need it. Seriously.",
                    "data-balloon-pos": "up",
                  },
                },
                [_vm._v("\n        Actual Human™ Support\n      ")]
              )
            : _c(
                "span",
                {
                  attrs: {
                    "aria-label":
                      "Get help from a real human when you need it. Seriously.",
                    "data-balloon-pos": "up",
                  },
                },
                [_vm._v("\n        Actual Human™ Support\n      ")]
              ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "margin-bottom-sm padding-left-sm" }, [
          _c(
            "span",
            { staticClass: "fa-li" },
            [
              _c("font-awesome-icon", {
                class: `${_vm.context.packages.iconColor}`,
                attrs: { icon: _vm.context.packages.icon, size: "lg" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.context.packages.hasAccessToPrivateNpm
            ? _c(
                "span",
                {
                  class: _vm.serviceStylingUnavailable,
                  attrs: {
                    "aria-label":
                      "This plan does not include access to Font Awesome Pro private packages and plugins.",
                    "data-balloon-pos": "up",
                    "data-balloon-length": "large",
                  },
                },
                [_vm._v("\n        No Hosted Packages or Plugins\n      ")]
              )
            : _c(
                "span",
                {
                  attrs: {
                    "aria-label":
                      "Access Font Awesome Pro private packages for building complex web apps.",
                    "data-balloon-pos": "up",
                    "data-balloon-length": "large",
                  },
                },
                [_vm._v("\n        Pro Packages + Plugins\n      ")]
              ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }